import { httpClient } from '@/api/http-client'
import { PartnerPayload, Partner } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type Params = {
  companyKey: string
  partnerData: PartnerPayload
}

export const createPartner = async ({ companyKey, partnerData }: Params) => {
  const response = await httpClient('accounting-dealer').post<Partner>(
    `/v3/company/${companyKey}/partner`,
    partnerData,
  )
  return response.data
}

export const useCreatePartner = (
  options?: UseMutationOptions<Partner, AxiosError, Params>,
) => {
  return useMutation({
    mutationFn: createPartner,
    ...options,
  })
}
